// export const host = window.location.href.includes("https") ? window.location.href : `https://${window.location.href.split("/")[2].split(".")[0]}-dev.myaccountplus.com`
// export const tenant = "/" + window.location.href.split("/")[2].split(".")[0] || localStorage.getItem("tenant")

export const baseUrl = getWithTrailingSlash(import.meta.env.VITE_API_BASE_URL!)
export const baseHost = import.meta.env.VITE_API_HOST!

function getWithTrailingSlash(url: string) {
    if (url.substring(-1) !== "/") {
        return url + "/";
    }
    return url;
}
const getTenant = localStorage.getItem("tenant");
export const tenant = (getTenant && getTenant.length > 0) ? getTenant : window.location.href.split("/")[2].split(".")[0].split("-")[0]
export const settingsUrl = import.meta.env.VITE_SETTINGS_API_URL || "VITE_SETTINGS_API_URL not set"

// if the API host is hard-coded, then use it.  Otherwise, just send request to the local host.  This will
// route things through nginx when deployed to server
export const host = (baseHost && baseHost.length > 0) ? baseHost.replace("{{tenant}}", tenant) : "";


export const api = {
    logos: "/logos",
    assets: "/assets",
    images: "/images",
    loginApi: "/login",
    logoutApi: "/logout",
    settings: "/settings",
    register: "/register",
    eligible: "/eligible",
    loginAsApi: "/login-as",
    permissions: "/permissions",
    newCustomer: "/new-customer",
    verifyEmail: "/verify-email",
    resetPassword: "/resetPassword",
    guestPayment: "/make-guest-payment",
    selfRegister: "/request-user-self-register",
}

export const configApi = {
    roles: "/roles",
    config: "/config",
    workflow: "/workflow",
    clearCache: "clearCaches",
    departments: "/departments",
    transactionTypes: "/transaction_types",
}

export const userApi = {
    user: "/user",
    inquiry: "/inquiry",
    profile: "/profile",
    accounts: "/accounts",
    password: "/password",
    documents: "/documents",
    userAccount: "/for-user",
    transactions: "/transactions",
    deliveries: "/deliveries",
    autopay: "/autopay",
    payment: "/payments",
    sourcePay: "/sources",
    makeDefault: "/make-default",
    make_payment: "/make-payment",
    autoPayPayment: "/autopayments",
    payment_sources: "/payment-sources",
    orders: "/orders",
    fuelOrderPrice: "/price-fuel-order",
    createFuelOrder: "/create-fuel-order",
    address: "/address",
}

export const adminApi = {
    list: "/list",
    find: "/find",
    role: "/role",
    user: "/users",
    profile: "/profile",
    inquiry: "/inquiry",
    accounts: "/accounts",
    fuelOrder: "/fuel_order",
    workflowAdvance: "/advance",
    confirmUser: "/confirm-user/",
    registerUser: "/register-user",
    accountApplication: "/account_application",
    notificationsConfig: "/notifications-config",
}